import {
  fetchShippingProfiles,
  fetchShippingProfilesSuccess,
  fetchShippingProfilesError,
  fetchShippingDestinations,
  fetchShippingDestinationsSuccess,
  fetchShippingDestinationsError,
  saveShippingProfile,
  saveShippingProfileSuccess,
  saveShippingProfileError,
  deleteShippingProfileSuccess,
  deleteShippingProfileError,
} from '../actions/shippingProfiles';
import { DeviationSubmitPopupStoreSlice } from '../types';

const DEFAULT_SHIPPING_PROFILES_STATE: DeviationSubmitPopupStoreSlice['shippingProfiles'] = {
  profiles: [],
  destinations: [],
  status: 'uninitialized',
  destinationsStatus: 'uninitialized',
  savingStatus: 'idle',
};

export default {
  [`${fetchShippingProfiles}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      status: 'fetching' as const,
    },
  }),
  [`${fetchShippingProfilesSuccess}`]: (
    state: DeviationSubmitPopupStoreSlice,
    action: ReturnType<typeof fetchShippingProfilesSuccess>
  ) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      profiles: action.payload.profiles,
      status: 'idle' as const,
    },
  }),
  [`${fetchShippingProfilesError}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      status: 'error' as const,
    },
  }),
  [`${fetchShippingDestinations}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      destinationsStatus: 'fetching' as const,
    },
  }),
  [`${fetchShippingDestinationsSuccess}`]: (
    state: DeviationSubmitPopupStoreSlice,
    action: ReturnType<typeof fetchShippingDestinationsSuccess>
  ) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      destinations: action.payload.destinations,
      destinationsStatus: 'idle' as const,
    },
  }),
  [`${fetchShippingDestinationsError}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      destinationsStatus: 'error' as const,
    },
  }),
  [`${saveShippingProfile}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      savingStatus: 'saving' as const,
    },
  }),
  [`${saveShippingProfileSuccess}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      savingStatus: 'idle' as const,
    },
  }),
  [`${saveShippingProfileError}`]: (state: DeviationSubmitPopupStoreSlice) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      savingStatus: 'idle' as const,
    },
  }),
  [`${deleteShippingProfileSuccess}`]: (
    state: DeviationSubmitPopupStoreSlice,
    action: ReturnType<typeof deleteShippingProfileSuccess>
  ) => ({
    ...state,
    shippingProfiles: {
      ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
      profiles: (state.shippingProfiles?.profiles ?? []).filter(
        p => p.shippingProfileid !== action.payload.profileId
      ),
    },
  }),
  [`${deleteShippingProfileError}`]: (
    state: DeviationSubmitPopupStoreSlice,
    action: ReturnType<typeof deleteShippingProfileError>
  ) => {
    if (!action.payload.isInUse) {
      return state;
    }
    return {
      ...state,
      shippingProfiles: {
        ...(state.shippingProfiles ?? DEFAULT_SHIPPING_PROFILES_STATE),
        profiles: (state.shippingProfiles?.profiles ?? []).map(p =>
          p.shippingProfileid === action.payload.profileId ? { ...p, isInUse: true } : p
        ),
      },
    };
  },
};
